/**
 * Skeleton loader for fixtures list - matches current fixtures row layout
 */
export function FixtureSkeleton() {
  return (
    <>
      {[...Array(2)].map((_, groupIndex) => (
        <div key={groupIndex} className="fixture-group mb-4 last:mb-0">
          {/* Sticky Date Header - exact same as RecentFixturesList */}
          <div
            className="sticky z-10 mb-1 rounded bg-gray-100 p-2 text-lg font-semibold dark:bg-gray-700"
            style={{ top: '56px' }}
          >
            <div className="h-5 w-32 animate-pulse rounded bg-gray-300 dark:bg-gray-500" />
          </div>

          {/* Fixture Items */}
          <FixtureItemSkeleton />
          <FixtureItemSkeleton />
          <FixtureItemSkeleton />
        </div>
      ))}
    </>
  );
}

/**
 * Single fixture item skeleton - individual card container like actual items
 */
function FixtureItemSkeleton() {
  return (
    <div
      className="mb-1 overflow-hidden rounded-lg bg-white p-2 pr-3 dark:bg-gray-800"
      style={{ containerType: 'inline-size' }}
    >
      <div className="fixture-skeleton-grid relative">
        {/* Caret */}
        <div className="absolute left-1 top-1 h-5 w-5 animate-pulse rounded bg-gray-300 dark:bg-gray-600" />

        {/* Vessel section */}
        <div className="fixture-skeleton-vessel pl-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="h-6 w-40 animate-pulse rounded bg-gray-300 dark:bg-gray-600" />
              <div className="h-5 w-5 animate-pulse rounded-full bg-gray-300 dark:bg-gray-600" />
            </div>
            <div className="h-4 w-16 animate-pulse rounded bg-gray-300 dark:bg-gray-600" />
          </div>
          <div className="mt-1 h-4 w-36 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
        </div>

        {/* Trade section */}
        <div className="fixture-skeleton-trade mt-2">
          <div className="flex items-center justify-between">
            <div className="h-5 w-24 animate-pulse rounded bg-gray-300 dark:bg-gray-600" />
            <div className="h-4 w-20 animate-pulse rounded bg-gray-300 dark:bg-gray-600" />
          </div>
          <div className="mt-1 h-4 w-28 animate-pulse rounded bg-gray-200 dark:bg-gray-700" />
        </div>

        {/* Earning section */}
        <div className="fixture-skeleton-earning mt-2 flex items-center justify-between">
          <div className="flex items-center gap-1">
            <div className="h-4 w-4 animate-pulse rounded bg-gray-300 dark:bg-gray-600" />
            <div className="h-4 w-14 animate-pulse rounded bg-gray-300 dark:bg-gray-600" />
          </div>
          <div className="h-4 w-16 animate-pulse rounded bg-gray-300 dark:bg-gray-600" />
        </div>
      </div>

      <style>{`
        .fixture-skeleton-grid {
          display: grid;
          grid-template-columns: 1fr;
        }

        .fixture-skeleton-vessel,
        .fixture-skeleton-trade,
        .fixture-skeleton-earning {
          padding: 0.25rem;
        }

        @container (min-width: 960px) {
          .fixture-skeleton-grid {
            grid-template-columns: repeat(5, 1fr);
            align-items: center;
          }

          .fixture-skeleton-vessel {
            grid-column: 1 / 3;
            margin-top: 0;
          }

          .fixture-skeleton-trade {
            grid-column: 3 / 5;
            margin-top: 0;
          }

          .fixture-skeleton-earning {
            grid-column: 5 / 6;
            margin-top: 0;
          }
        }

        @media (max-width: 576px) {
          .fixture-skeleton-vessel,
          .fixture-skeleton-trade,
          .fixture-skeleton-earning {
            padding: 0.25rem 0;
          }
        }
      `}</style>
    </div>
  );
}
